// Dashboard Vuex

import state from './authStates.js'
import * as getters from './authGetters.js'
import * as mutations from './authMutations.js'
import * as actions from './authActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
